import { InjectionToken } from '@angular/core';
import { seoConfig } from 'src/app/shared/interfaces/index.interface';

export const SEO_CONFIG = new InjectionToken<seoConfig>('SEO_CONFIG');
